<div class="page-content bg-light">
    <div class="dz-bnr-inr bg-secondary dz-bnr-inr-md"
        style="background-image:url(https://ezhuthupizhai.in/wp-content/uploads/2024/03/Banner_3-scaled-1.jpg);">
        <div class="container">
            <div class="row">
                <div class="col-lg-6">
                    <div class="dz-bnr-inr-entry text-start">
                        <h1 class="text-white">Book Photo Gallery</h1>
                        <nav aria-label="breadcrumb" class="breadcrumb-row">
                            <ul class="breadcrumb text-white">
                                <li class="breadcrumb-item"><a href="/home" class="text-white"> Home</a></li>
                                <li class="breadcrumb-item text-white">Gallery</li>
                            </ul>
                        </nav>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <section class="content-inner pt-0 z-index-unset overflow-hidden">
        <div class="site-filters style-2 clearfix center">
            <ul class="filters tamil" data-bs-toggle="buttons">
                <li *ngFor="let filter of productFilters" class="btn" [class.active]="filter === activeFilter"
                    (click)="filterImages(filter)">
                    <a href="javascript:void(0);">{{ filter }}</a>
                </li>
            </ul>
        </div>
        <div class="container">
            <div class="clearfix">
                <div class="text-center" *ngIf="loading">
                    <p>Loading...</p>
                </div>
                <ul id="masonry" class="lightgallery row" *ngIf="filteredImages.length > 0 && !loading">
                    <li *ngFor="let image of filteredImages"
                        [class]="'card-container col-xl-4 col-lg-4 col-md-6 m-b30 All ' + slugify(image.product)">
                        <div class="portfolio-box style-1">
                            <div class="dz-media">
                                <img [src]="image.gallery_image" [alt]="image.product" width="400" height="300"
                                    loading="lazy">
                            </div>
                        </div>
                    </li>
                </ul>
                <div *ngIf="filteredImages.length === 0 && !loading" class="text-center">
                    <p>No images found for this product.</p>
                </div>
            </div>
        </div>
    </section>
</div>